var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 81,
    viewBox: "0 0 82 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.0002 77.3333C61.1668 77.3333 77.6668 60.8333 77.6668 40.6667C77.6668 20.5 61.1668 4 41.0002 4C20.8335 4 4.3335 20.5 4.3335 40.6667C4.3335 60.8333 20.8335 77.3333 41.0002 77.3333Z",
    stroke: "#F1982E",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41 26V44.3333",
    stroke: "#F1982E",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.98 55.334H41.0137",
    stroke: "#F1982E",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.2a087120b4e570e99314f1b68692e032.svg";
export { ForwardRef as ReactComponent };